//Core
import React from "react"

//Components
import StepByStepWithImage from "../../components/StepByStepWithImage"
import Card from "../../components/Card"
import Header from "./Header"
import FormPudra from "./FormPudra"

//Config
import { pudraAdvantages } from "../../config/cards"

//Images
import first from "../../images/pudra/1.png"
import second from "../../images/pudra/2.png"
import third from "../../images/pudra/3.png"

import pudra from "../../images/pudra.svg"

const steps = [
  {
    img: first,
    text: `Замов картку зараз`,
  },
  {
    img: second,
    number: "2",
    text: `Очікуй на дзвінок представника банку `,
  },
  {
    img: third,
    number: "3",
    text: `Отримай картку`,
  },
]

const card = {
  // cardTitle: "",
  list: pudraAdvantages,
  cardImage: pudra,
  titleColor: "#b22b59",
  bulletColor: "#E8AEC2",
  title: "Всі переваги ідеального шопінгу з ",
  titleBefore: "#PudraCard",
}
const backgroundSteps = { backgroundImage: "unset", backgroundColor: "#ffff" }

const Pudra = () => {
  return (
    <div>
      <Header></Header>
      <Card {...card}></Card>
      <StepByStepWithImage
        title={`Три прості кроки до твоєї найкращої б’юті-помічниці`}
        titleColor={"#b22b59"}
        list={steps}
        full={true}
        background={backgroundSteps}
      ></StepByStepWithImage>
      <FormPudra
        link={"https://forms.tascombank.ua/api/v1/journal/attraction"}
        source={"Landing_Pudra"}
        product={85}
      ></FormPudra>
    </div>
  )
}

export default Pudra
